import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2c69126c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "error-page" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"font-size":"50px","font-weight":"bolder","letter-spacing":"1.5px"} }, " 404 ", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "访问页面不存在", -1))
const _hoisted_4 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _hoisted_2,
      _hoisted_3,
      _createElementVNode("div", null, [
        _createVNode(_component_el_button, {
          text: "",
          onClick: _ctx.goBack
        }, {
          default: _withCtx(() => [
            _createTextVNode("返回上一页")
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_el_button, {
          type: "primary",
          text: "",
          onClick: _ctx.goHome
        }, {
          default: _withCtx(() => [
            _createTextVNode("返回主页")
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ]),
    _createElementVNode("img", {
      style: {"height":"400px"},
      src: `${_ctx.FILESERVICE}/file/tms/frontend/error_page/404.gif`
    }, null, 8, _hoisted_4)
  ]))
}